import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { SHIPMENT_ITEM } from '../types/shipment-item.js';
/**
 * Descriptor for ShipmentItem.
 * Path: org/{orgId}/shipment/{shipmentId}/item
 */
export const shipmentItemDescriptor = {
    name: SHIPMENT_ITEM,
    label: 'Item da expedição',
    domain: 'sales',
    collectionPath: 'org/{orgId}/shipment/{shipmentId}/item',
    pathPatternKeys: {
        orgId: 'string',
        shipmentId: 'string',
    },
    version: 1,
    description: 'Shipment line — ProductRef + lot + location + qty',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        { name: 'shipmentId', label: 'Expedição', type: 'string', required: true },
        { name: 'salesOrderItemId', label: 'Item do pedido', type: 'string', required: true },
        { name: 'productId', label: 'Produto', type: 'string', required: true },
        { name: 'variantId', label: 'Variante', type: 'string', required: false },
        { name: 'lotId', label: 'Lote', type: 'string', required: false },
        { name: 'stockLocationId', label: 'Local', type: 'string', required: true },
        { name: 'quantity', example: 250, label: 'Quantidade', type: 'number', required: true },
    ],
    foreignKeys: [
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'lotId',
            targetEntity: 'Lot',
            relationship: 'many-to-one',
            displayField: 'lotNumber',
        },
        {
            fieldName: 'stockLocationId',
            targetEntity: 'StockLocation',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'salesOrderItemId',
            targetEntity: 'SalesOrderItem',
            relationship: 'many-to-one',
            displayField: 'description',
        },
    ],
};
//# sourceMappingURL=shipment-item.descriptor.js.map